type CmsFormValidationErrors = Record<string, string>;

export function createCmsFormState() {
	let submitting = $state(false);
	let success = $state(false);
	let errors = $state.raw<CmsFormValidationErrors>({});
	let errorMessage = $state<string | undefined>(undefined);

	async function submit(formElement: HTMLFormElement, fallbackErrorMessage: string) {
		submitting = true;
		success = false;
		errorMessage = undefined;
		errors = {};

		try {
			const response = await fetch('/api/forms', {
				method: 'POST',
				body: new FormData(formElement)
			});
			const result = (await response.json()) as unknown;

			if (!response.ok) {
				const validationErrors =
					response.status === 409 ? parseValidationErrors(result) : undefined;

				if (validationErrors) {
					errors = validationErrors;
				} else {
					errorMessage = fallbackErrorMessage;
				}

				return false;
			}

			success = true;
			return true;
		} catch {
			errorMessage = fallbackErrorMessage;
			return false;
		} finally {
			submitting = false;
		}
	}

	return {
		submitting() {
			return submitting;
		},
		success() {
			return success;
		},
		errorMessage() {
			return errorMessage;
		},
		errors() {
			return errors;
		},
		error(fieldId: string) {
			return errors[fieldId] ?? '';
		},
		submit,
		reset() {
			submitting = false;
			success = false;
			errorMessage = undefined;
			errors = {};
		}
	};
}

function parseValidationErrors(value: unknown): CmsFormValidationErrors | undefined {
	if (isStringRecord(value)) {
		return value;
	}

	if (
		value !== null &&
		typeof value === 'object' &&
		'message' in value &&
		isStringRecord(value.message)
	) {
		return value.message;
	}

	return undefined;
}

function isStringRecord(value: unknown): value is Record<string, string> {
	return (
		value !== null &&
		typeof value === 'object' &&
		Object.values(value).every((message) => typeof message === 'string')
	);
}
